// @flow
export const API_ERROR_EMAIL_REGISTERED = 'Email ID already registered';
